import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ApiClient from "../../api-client";
import { apiUrl, PORT } from "../../environment";
import { toasterConfig } from "../../utils/constants";

toast.configure();
export const getNotificationDetails = (params, callback) => {
    // console.log("get notification",params)
      return (dispatch, getState) => {
        const {
            user: { token },
        } = getState();
          ApiClient.get(`${apiUrl}${PORT}/notification/getNotificationDetails`, params, token, dispatch).then(
          (response) => {
            if (response && !response.errors) {
              dispatch({type:'NOTIFICATION_LIST',payload:response.data})
              callback(response);
            } else if (response.code === 404) {
              toast.error(response.message);
            } else {
              toast.error(response.errors.msg, toasterConfig);
            }
          }
        );
      };
    };
  

  
  